
export default {
  methods: {
    transform(value) {
      return this.$t(value)
    },
    leftLocales() {
      return this.$i18n.availableLocales.filter(key => !this.$i18n.locale.startsWith(key))
    },
    getAlpha2Code(lang) {
      return this.$i18n.messages[lang]['alpha2']
    },
    getOfficial(lang) {
      return this.$i18n.messages[lang]['official']
    },
    getCommon(lang) {
      return this.$i18n.messages[lang]['common']
    },
    getAcceptLanguage() {
      var array = this.$i18n.availableLocales
      array.unshift(this.$i18n.locale)
      return array.join(',')
    },
    switchLang(lang) {
      if (this.leftLocales().includes(lang)) {
        this.$i18n.locale = lang
      }
    },
    getLocalizedOfficialName(item) {
      const path = this.getOfficial(this.$i18n.locale)
      var name = item
      path.split('.').forEach(s => {
        if (name[s] !== undefined) {
          name = name[s]
        }
      })
      return name
    },
    getLocalizedCommonName(item) {
      const path = this.getCommon(this.$i18n.locale)
      var name = item
      path.split('.').forEach(s => {
        if (name[s] !== undefined) {
          name = name[s]
        }
      })
      return name
    }
  }
}
